<template>
  <v-container fluid class="login-full">
    <v-row no-gutters v-if="!isShowIncomeType" >
      <v-col md="3" cols="12" class="pa-2">
        <v-card>
          <v-card-title>
            Income
            <v-spacer></v-spacer>
            <v-btn depressed fab small color="primary" outlined>
              <v-icon>help</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid" v-on:submit.prevent lazy-validation>
              <v-row no-gutters>
                <v-col cols="12" md="12" class="pb-2">
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="290px"
                    v-model="fromMeun"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="fromDateValue"
                        name="fromReceiveDate"
                        label="Receive Date"
                        hide-details
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :allowed-dates="allowedDate"
                      :type="datePickerType"
                      v-model="fromDate"
                      @input="fromMeun = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="12" class="pt-3">
                  <v-autocomplete
                    :rules="[v => !!v || 'Income Type is required']"
                    v-model="income.incomeTypeDto"
                    item-text="incomeTypeName"
                    :items="incomeTypeList"
                    name="incomeTypeDto"
                    label="Income Type"
                    placeholder=" "
                    hide-details
                    return-object
                    required
                    dense
                  >
                    <template v-slot:append-outer>
                      <v-slide-x-reverse-transition mode="out-in">
                        <v-icon color="primary" @click="showIncomeType">add_circle</v-icon>
                      </v-slide-x-reverse-transition>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="10" md="12" class="pt-2">
                  <v-text-field
                    v-model="income.transactionDto.payment"
                    :rules="incomeTypeNameRule"
                    name="incomeTypePayment"
                    label="Payment"
                    placeholder=" "
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="2" md="12">
                  <v-btn
                    v-if="income.status=='ADD'"
                    @click="addIncome()"
                    :disabled="!valid"
                    color="success"
                    class="ma-1"
                    depressed
                  >
                    <v-icon>add</v-icon>
                    <span class="ml-2 d-none d-sm-flex">Add</span>
                  </v-btn>
                </v-col>
                <v-col cols="12" md="12">
                  <v-btn
                    v-if="income.status=='UPDATE'"
                    @click="updateIncome"
                    :disabled="!valid"
                    color="success"
                    class="ma-1"
                    depressed
                  >
                    <v-icon>edit</v-icon>
                    <span class="ml-2">Update</span>
                  </v-btn>
                  <v-btn
                    v-if="income.status=='UPDATE'"
                    @click="cancelIncome"
                    :disabled="!valid"
                    color="error"
                    class="ma-1"
                    depressed
                    outlined
                  >
                    <v-icon>close</v-icon>
                    <span class="ml-2">Cancel</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="9" cols="12" class="pa-2">
        <v-card>
          <v-card-title>Income List</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="incomeHeader"
              :page-count="pageCount"
              :items="incomeList"
              :items-per-page="10"
              :page.sync="page"
              hide-default-footer
              class="tbl-info"
            >
              <template
                v-slot:item.transactionDto.payment="{ item }"
              >{{ item.transactionDto.payment | defaultPaymentFormat}}</template>
              <template v-slot:item.action="{ item }">
                <v-btn icon depressed color="primary" @click="editIncome(item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn icon depressed color="error" @click="deleteIncome(item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <div class="text-center pt-2">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="isShowIncomeType">
      <v-col md="3" cols="12" class="pa-2">
        <v-card>
          <v-card-title>Income Type</v-card-title>
          <v-card-text>
            <v-form
              ref="incomeTypeForm"
              v-model="validIncomeType"
              v-on:submit.prevent
              lazy-validation
            >
              <v-text-field
                v-model="incomeType.incomeTypeName"
                :rules="incomeTypeRules"
                name="incomeTypeName"
                label="Income Type"
                required
              ></v-text-field>
              <v-btn
                v-if="incomeType.status=='ADD'"
                depressed
                :disabled="!validIncomeType"
                color="success"
                class="ma-1"
                @click="addIncomeType"
              >Add</v-btn>
              <v-btn
                v-if="incomeType.status=='UPDATE'"
                depressed
                :disabled="!validIncomeType"
                color="success"
                class="ma-1"
                @click="updateIncomeType"
              >Update</v-btn>
              <v-btn
                v-if="incomeType.status=='UPDATE'"
                depressed
                color="info"
                class="ma-1"
                @click="cancelUpdate"
              >Cancel</v-btn>
              <v-btn
                v-if="incomeType.status=='ADD'"
                depressed
                color="error"
                outlined
                class="ma-1"
                @click="showIncomeType"
              >Exit</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="9" cols="12" class="pa-2">
        <v-card>
          <v-card-title>Income Type List</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="incomeTypeHeader"
              :items="incomeTypeList"
              :items-per-page="5"
              class="elevation-0"
            >
              <template v-slot:item.action="{ item }">
                <v-btn icon depressed color="primary" @click="editIncomeType(item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn icon depressed color="error" @click="deleteIncomeType(item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import incomeService from "../service/IncomeService";
import { allowedDate } from "../utils";

export default {
  data() {
    return {
      toMeun: false,
      fromMeun: false,
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: new Date().toISOString().substr(0, 10),
      dateType: "date",
      datePickerType: "date",
      page: 1,
      pageCount: 1,
      valid: false,
      validIncomeType: false,
      isShowIncomeType: false,
      incomeType: {
        status: "ADD",
      },
      income: {
        incomeTypeDto: {
          incomeTypeName: "",
        },
        transactionDto: {
          payment: 1,
        },
        status: "ADD",
      },
      incomeTypeNameRule: [
        (v) => !!v || "Income Payment is required",
        (v) => (v && v > 0) || "Income Payment must be greater than 0",
      ],
      incomeTypeRules: [(v) => !!v || "Income Type is required"],
      incomeTypeHeader: [
        { text: "Income Type", value: "incomeTypeName" },
        { text: "Action", value: "action" },
      ],
      incomeHeader: [
        { text: "Income Type", value: "incomeTypeDto.incomeTypeName" },
        { text: "Payment", value: "transactionDto.payment" },
        {
          text: "User Account",
          value: "transactionDto.userAccountDto.profileName",
        },
        { text: "Receive Date", value: "transactionDto.receiveDate" },
        { text: "Modified Date", value: "transactionDto.modifiedDate" },
        { text: "Action", value: "action" },
      ],
      incomeTypeList: [],
      incomeList: [],
    };
  },
  mounted: function () {
    this.getIncomeType();
    let i = 0;
    var reportTitle, typeId, dateType;
    if (this.$route.query.reportTitle != undefined) {
      reportTitle = this.$route.query.reportTitle;
      i++;
    }
    if (this.$route.query.typeId != undefined) {
      typeId = this.$route.query.typeId;
      i++;
    }
    if (this.$route.query.dateType != undefined) {
      dateType = this.$route.query.dateType;
      i++;
    }
    if (i == 3) {
      this.getIncome(1, typeId, reportTitle, dateType);
    } else {
      this.getIncome(1, 0, "", "");
    }
  },
  watch: {
    page: function () {
      this.getIncome(this.page, 0, "", "");
    },
  },
  methods: {
    addIncome: function () {
      if (this.$refs.form.validate()) {
        this.income.transactionDto.receiveDate = this.fromDateValue;
        incomeService
          .addIncome(this.income)
          .then(() => {
            //this.$swal("Successful", "Added New Income Successful!", "success");
            this.$swal({
     title: "Successful",
     text: "Added New Income Successful!",
     type: "success",
     timer: 500
     });
            this.getIncome(1, 0, "", "");
            // this.$refs.form.reset();
            this.income.transactionDto.payment = 0;
          })
          .catch((err) => {
            this.$swal("Failed", err.response.data.message, "error");
          });
      }
    },
    getIncome: function (pagination, id, reportTitle, dateType) {
      incomeService
        .getIncome(pagination, id, reportTitle, dateType)
        .then((response) => {
          if (response.incomeList != undefined) {
            this.incomeList.splice(0, this.incomeList.length);
            this.incomeList.push(...response.incomeList);
            if (response.size > 10) {
              this.pageCount = Math.ceil(response.size / 10);
            }
          }
        });
    },
    editIncome: function (income) {
      this.income = JSON.parse(JSON.stringify(income));
      this.fromDateValue = this.formatDate(income.transactionDto.receiveDate);
      this.income.status = "UPDATE";
    },
    updateIncome: function () {
      if (this.$refs.form.validate()) {
        this.income.transactionDto.receiveDate = this.fromDateValue;
        incomeService
          .updateIncome(this.income)
          .then(() => {
            //this.$swal("Updated Successful", "Income is Updated!", "success");
this.$swal({
     title: "Successful",
     text: "Income is Updated!",
     type: "success",
     timer: 500
     });
            this.getIncome(this.page, 0, "", "");
            // this.$refs.form.reset();
            this.income.transactionDto.payment = 0;
            this.income.status = "ADD";
          })
          .catch((err) => {
            this.$swal("Failed", err.response.data.message, "error");
          });
      }
    },
    deleteIncome: function (income) {
      incomeService
        .deleteIncome(income)
        .then(() => {
         // this.$swal("Delete Successful", "Income is Delete!", "success");
          this.$swal({
     title: "Successful",
     text: "Income is Delete!",
     type: "success",
     timer: 500
     });
          this.getIncome(this.page, 0, "", "");
          // this.$refs.form.reset();
          this.income.status = "ADD";
        })
        .catch((err) => {
          this.$swal(
            "Failed",
            "This data is used in somewhere Or " + err.response.data.message,
            "error"
          );
        });
    },
    cancelIncome: function () {
      // this.$refs.form.reset();
      this.income = {
        incomeTypeDto: {
          incomeTypeName: "",
        },
        transactionDto: {
          payment: 0,
        },
        status: "ADD",
      };
    },
    // IncomeType
    editIncomeType: function (incomeType) {
      this.incomeType = Object.assign({}, incomeType);
      this.incomeType.status = "UPDATE";
    },
    deleteIncomeType: function (incomeType) {
      incomeService
        .deleteIncomeType(incomeType)
        .then(() => {
          this.getIncomeType();
          this.$refs.incomeTypeForm.reset();
          this.incomeType.status = "ADD";
          //this.$swal("Delete Successful", "IncomeType is Delete!", "success");
           this.$swal({
     title: "Successful",
     text: "IncomeType is Delete!",
     type: "success",
     timer: 500
     });
        })
        .catch((err) => {
          this.$swal(
            "Failed",
            "This data is used in somewhere Or " + err.response.data.message,
            "error"
          );
        });
    },
    updateIncomeType: function () {
      if (this.$refs.incomeTypeForm.validate()) {
        incomeService
          .updateIncomeType(this.incomeType)
          .then(() => {
            this.getIncomeType();
            this.$refs.incomeTypeForm.reset();
            this.incomeType.status = "ADD";
          })
          .catch((err) => {
            this.$swal("Failed", err.response.data.message, "error");
          });
      }
    },
    getIncomeType: function () {
      incomeService.getIncomeType().then((response) => {
        this.incomeTypeList.splice(0, this.incomeTypeList.length);
        this.incomeTypeList.push(...response);
        if (response.length != 0) {
          this.income.incomeTypeDto = response[0];
        }
      });
    },
    addIncomeType: function () {
      if (this.$refs.incomeTypeForm.validate()) {
        incomeService
          .addIncomeType(this.incomeType)
          .then(() => {
            this.getIncomeType();
            this.$refs.incomeTypeForm.reset();
          })
          .catch((err) => {
            this.$swal("Failed", err.response.data.message, "error");
          });
      }
    },
    cancelUpdate: function () {
      this.$refs.incomeTypeForm.reset();
      this.incomeType = {};
      this.incomeType.status = "ADD";
    },
    showIncomeType: function () {
      if (this.isShowIncomeType == false) {
        this.isShowIncomeType = true;
      } else {
        this.isShowIncomeType = false;
      }
    },
    formatDateUrl(date) {
      //if (!date) return null;
      if (this.dateType == "month") {
        const [month, year] = date.split("-");
        return `01-${month}-${year}`;
      } else if (this.dateType == "year") {
        const [year] = date.split("-");
        return `01-01-${year}`;
      }
      return date;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.dateType == "date") {
        // const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      } else if (this.dateType == "month") {
        // const [year, month, day] = date.split("-");
        return `${month}-${year}`;
      } else {
        // const [year, month, day] = date.split("-");
        return `${year}`;
      }
    },
    allowedDate: allowedDate,
  },
  computed: {
    toDateValue: {
      get: function () {
        var toDatetemp = "";
        toDatetemp = this.formatDate(this.toDate);
        return toDatetemp;
      },
      set: function (value) {
        this.toDate = value;
      },
    },
    fromDateValue: {
      get: function () {
        var fromDatetemp = "";
        fromDatetemp = this.formatDate(this.fromDate);
        return fromDatetemp;
      },
      set: function (value) {
        this.fromDate = value;
      },
    },
  },
};
</script>
<style scoped>
.login-full {
  height: 92vh;
}
</style>